import { gql } from '@apollo/client'
import { buildGraphqlQuery } from '@ztechapps/common.utils'

export const chatFragment = gql`
  fragment chatFragment on Chat {
    _id
    code
    status
    sender {
      _id
      profile {
        _id
        name
        email
        picture
      }
    }
    assignee {
      _id
      profile {
        _id
        name
        picture
      }
    }
    requester {
      _id
      profile {
        _id
        name
        picture
      }
    }
    isRequesterLinked
    ccEmails
    tags
    remarks
    unreadForAgentCount
    lastMessageAt
    subject
    externalId
  }
`

export const chatMessagesFragment = gql`
  fragment chatMessagesFragmet on ChatMessage {
    _id
    attachments {
      _id
      name
      mimetype
      uri
      isInline
    }
    chat {
      _id
      subject
      externalId
      metadata {
        _id
        orderId
        purchaseOrderId
      }
    }
    content
    plainContent
    timeStamp
    isUnread
    sender {
      _id
      profile {
        _id
        name
        email
      }
    }
  }
`

export const chatMessageQuery = buildGraphqlQuery('ChatMessage', chatMessagesFragment)

export const allChatQuery = gql`
  ${chatFragment}
  query allChat($filter: JSON!, $options: JSON) {
    allChat(filter: $filter, options: $options) {
      ...chatFragment
    }
  }
`
